// Module
var code = "<div ng-if=\"!isMobile\"> <runner-page-description is-show=\"!isMobile\" page-header-text=\"Process Analytics\" page-description=\"Process reporting.\"></runner-page-description> <exago-report report-mode=\"'FullUI'\"></exago-report> </div> ";
// Exports
export default code;